import { EventsSnapshotsTab } from "./EventsSnapshotsTab";

export default EventsSnapshotsTab;
